/**
 * Módulo de Presentación del Escáner (scannerUI.js)
 * Maneja overlays de resultados, linterna y eventos de interacción del DOM.
 * Cumple con .idx-rules.md: funciones < 40 líneas.
 */

/**
 * Controla el encendido/apagado físico de la linterna y actualiza el botón.
 */
export async function toggleFlashlight(activeStream, flashState) {
  if (!activeStream) return false;
  const track = activeStream.getVideoTracks()[0];
  const capabilities = track.getCapabilities ? track.getCapabilities() : {};

  if (!capabilities.torch) {
    alert('Linterna no soportada en este dispositivo/navegador.');
    return flashState;
  }

  try {
    const newState = !flashState;
    await track.applyConstraints({ advanced: [{ torch: newState }] });
    updateFlashButtonState(newState);
    return newState;
  } catch (error) {
    console.error('Error al aplicar linterna:', error);
    return flashState;
  }
}

/**
 * Verifica si el dispositivo soporta linterna y muestra/oculta el botón.
 */
export function checkFlashlightCapability(stream) {
  const track = stream.getVideoTracks()[0];
  const capabilities = track.getCapabilities ? track.getCapabilities() : {};
  const btn = document.getElementById('btn-toggle-flashlight');
  if (btn) {
    btn.style.display = capabilities.torch ? 'inline-flex' : 'none';
  }
}

/**
 * Actualiza el estado visual del botón de la linterna.
 */
export function updateFlashButtonState(flashState) {
  const btn = document.getElementById('btn-toggle-flashlight');
  if (btn) {
    btn.classList.toggle('active', flashState);
    btn.innerHTML = flashState ? '🔦 Linterna ON' : '🔦 Linterna OFF';
  }
}

/**
 * Renderiza la tarjeta de resultado de validación sobre la cámara.
 */
export function renderScanResultOverlay(result) {
  const overlay = document.getElementById('scan-result-overlay');
  if (!overlay) return;

  const title = overlay.querySelector('.result-title');
  const details = overlay.querySelector('.result-details');

  overlay.className = 'scan-result-overlay active ' + (result.allowed ? 'allowed' : 'rejected');

  if (result.allowed) {
    title.innerHTML = result.isFrequent ? '🏆 CLIENTE FRECUENTE / VIP' : '✅ ACCESO PERMITIDO';
    details.innerHTML = `
      <p><strong>Nombre:</strong> ${result.fullName}</p>
      <p><strong>Edad:</strong> ${result.age} años (Mayor de Edad)</p>
      <p><strong>Género:</strong> ${result.gender === 'M' ? 'Masculino' : 'Femenino'}</p>
      <p><strong>Visitas este mes:</strong> ${result.visitCount}</p>
    `;
  } else {
    title.innerHTML = '❌ ACCESO DENEGADO';
    details.innerHTML = `
      <p><strong>Motivo:</strong> ${result.detail || result.reason}</p>
      <p><strong>Nombre:</strong> ${result.fullName || 'No leido'}</p>
      <p><strong>Edad:</strong> ${result.age ? result.age + ' años' : 'N/A'}</p>
    `;
  }
}

/**
 * Muestra una alerta simple de escaneo.
 */
export function showScanAlert(msg, success) {
  alert((success ? '🟢 ' : '🔴 ') + msg);
}

/**
 * Registra los listeners de interacción en el DOM de la vista del escáner.
 */
export function initCameraUIHandlers(captureFn, uploadFn, closeResultFn, toggleFlashFn) {
  document.getElementById('btn-capture-scan')?.addEventListener('click', captureFn);
  document.getElementById('input-system-camera')?.addEventListener('change', uploadFn);
  document.getElementById('btn-toggle-flashlight')?.addEventListener('click', toggleFlashFn);
  document.getElementById('btn-close-result')?.addEventListener('click', closeResultFn);
}
